import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

// Failed payment: 7-day grace with full access, then publishing pauses until the card is fixed.
export default function DunningBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  if (!user?.past_due) return null;
  const left = user.grace_until ? Math.max(0, Math.ceil((new Date(user.grace_until) - new Date()) / 86400000)) : 0;
  return (
    <div data-testid="dunning-banner" className="mb-6 rounded-xl border border-rose-500/40 bg-rose-500/10 px-5 py-3 flex items-center justify-between gap-3 flex-wrap">
      <p className="text-sm flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-rose-300 shrink-0" />
        {user.billing_restricted
          ? <span>Your payment failed and the grace period ended. Publishing is paused until you update your card.</span>
          : <span>Your last payment failed. Update your card within <span className="font-semibold text-rose-200" data-testid="dunning-days-left">{left} day{left === 1 ? "" : "s"}</span> to keep publishing.</span>}
      </p>
      <Button size="sm" onClick={() => navigate("/billing")} className="bg-rose-500 hover:bg-rose-500/90 text-white" data-testid="dunning-update-card">Update payment</Button>
    </div>
  );
}
